const settings = {
  scene1: {
    title: 'add your own text',
    logo: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Flogo.png?alt=media&token=60cad8fb-0724-487f-93ed-75e58464f415'
  },
  scene2: {
    title: 'YOUR TITLE HERE',
    text: 'Customize your attention grabbing subheading here.',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg1.jpg?alt=media&token=a53db14d-3eb9-48e7-8543-08ead150d4ba'
  },
  scene3: {
    title: 'Rosie the Rieveter',
    text: 'Functional and fashionable! Working women of the 40\'s wore scarves to protect their hair - a trend still popular today.',
    year: '1940\'s',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg2.jpg?alt=media&token=5ab3d1e6-3a71-4c03-93c6-4840f3e3beb5',
    gradient: false
  },
  scene4: {
    title: 'Audrey Hepburn',
    text: 'Oh, Audrey. No one pulls off a neckerchief quite like the Queen of gamine charm.',
    year: '1952',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg3.jpg?alt=media&token=e4a28f80-b76b-4dff-bf31-f099250cb71b'
  },
  scene5: {
    title: 'Jimi Hendrix',
    text: 'Draped around his neck and hanging low. Jimi Hendrix knew how to rock his signature silk scarves.',
    year: '1967',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg4.jpg?alt=media&token=de900147-06e4-4905-894b-102264675c45'
  },
  scene6: {
    title: 'David Bowie',
    text: 'Everyone\'s favorite gender-bending pop icon from the 70\'s was rarely seen without a scarf.',
    year: '1974',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg1.jpg?alt=media&token=a53db14d-3eb9-48e7-8543-08ead150d4ba'
  },
  scene7: {
    title: 'Stevie Nicks',
    text: 'Boho-chic pioneer, Stevie Nicks, looking graceful and hip in a billowing below-the-knee scarf.',
    year: '1983',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg2.jpg?alt=media&token=5ab3d1e6-3a71-4c03-93c6-4840f3e3beb5'
  },
  scene8: {
    title: 'Amy Winehouse',
    text: 'Amy\'s signature retro look and legendary scarf collection left an undeniable impression on the fashion world.',
    year: '2007',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg3.jpg?alt=media&token=e4a28f80-b76b-4dff-bf31-f099250cb71b'
  },
  scene9: {
    title: 'Beyoncé',
    text: 'Strong. Confident. Flawless. Beyoncé knows best when it comes to rocking a headscarf and cat-eye sunglasses.',
    year: '2014',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg4.jpg?alt=media&token=de900147-06e4-4905-894b-102264675c45'
  },
  scene10: {
    title: 'Daily Dose of Style',
    text: 'Unlock Your signature style with expert fashion tips sent right to Your email.',
    bg: 'https://firebasestorage.googleapis.com/v0/b/instant-apps.appspot.com/o/templates%2FfashionIcon%2Fbg-signup.jpg?alt=media&token=a80f6aeb-edab-46ff-bad1-705fae78589c',
    buttonText: 'Sign Up',
  },
  appSettings: {
    title: 'Instant App'
  }
}

export default settings



// WEBPACK FOOTER //
// ./src/templates/fashionIcon/template/settings.js